import CustomFilterSelect from "./CustomFilterSelect";

const FilterAchMethod = (props: any) => {
  const FilterData = [
    { id: "SYSTEM", name: "System" },
    { id: "USER", name: "User" },
  ];
  const authrole = localStorage?.getItem("authrole")?.toString();
  return (
    <CustomFilterSelect
      source="achMethod"
      label="Method"
      choices={FilterData}
      before={props?.before != null && props.before !== "" ? props.before : ""}
    />
  );
};

export default FilterAchMethod;
